export enum GarmentPart {
  TOP = 'TOP',
  BOTTOM = 'BOTTOM',
  JACKET = 'JACKET',
  DUPATTA = 'DUPATTA',
  INNER = 'INNER',
  FULL_SET = 'FULL_SET',
  SLEEVES = 'SLEEVES',
  FRONT = 'FRONT',
  BACK = 'BACK',
  COLLAR = 'COLLAR',
  LACE = 'LACE',
  LATKAN = 'LATKAN',
  FRONT_NECK_PATCH = 'FRONT NECK PATCH'
}


export enum GarmentSize {
  XS = 'XS',
  S = 'S',
  M = 'M',
  L = 'L',
  XL = 'XL',
  XXL = 'XXL',
  THREE_XL = '3XL'
}

// Array of all garment parts for easy iteration
export const GARMENT_PARTS = Object.values(GarmentPart);

// Array of all garment sizes for easy iteration
export const GARMENT_SIZES = Object.values(GarmentSize);

// Material constants
export const MATERIAL_CONSTANTS = {
  TYPES: {
    FABRIC: 'Fabric',
    LACE: 'Lace',
    BUTTON: 'Button'
  },
  UOMS: ['meter', 'yard', 'piece', 'kg', 'gram']
}; 